import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";
import { AddRounded } from "@mui/icons-material";
import Sidebar from "../components/common/Sidebar";
import DonorTable from "../components/Donor/DonorTable";
import Header from "../components/common/Header";
import PageBreadcrumbs from "../components/common/PageBreadcrumbs";

export default function Donor() {

  let navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", minHeight: "100dvh" }}>
      <Header />
      <Sidebar />
      <Box
        component="main"
        className="MainContent"
        sx={{
          px: { xs: 2, md: 6 },
          pt: {
            xs: "calc(12px + var(--Header-height))",
            sm: "calc(12px + var(--Header-height))",
            md: 3,
          },
          pb: { xs: 2, sm: 2, md: 3 },
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          gap: 1,
          bgcolor: "background.body",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PageBreadcrumbs
            links={[
              { label: "Donation", href: "/donation" },
            ]}
            current="Donor"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            mb: 1,
            gap: 1,
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "start", sm: "center" },
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <Typography level="h2" component="h1">
            Donor
          </Typography>
          <Button
            color="primary"
            startDecorator={<AddRounded />}
            size="sm"
            onClick={() => {
              navigate("/donation/add");
            }}
          >
            Add Donor
          </Button>
        </Box>
        <DonorTable />
        {/* <OrderList /> */}
      </Box>
    </Box>
  );
}
